import styled from 'styled-components';

import { media } from 'helpers/breakpoints';

const Container = styled.div`
  overflow-x: hidden;
`;

const Heading = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1px;
  margin-bottom: ${({ theme }) => theme.spacing.S8};
`;

const Title = styled.p`
  ${({ theme }) => theme.fontSize.L18};
  color: ${({ theme }) => theme.colors.GREY_DARKER};
  font-weight: ${({ theme }) => theme.fontWeight.bold};
`;

const NavigationButtonContainer = styled.div`
  display: flex;
  gap: ${({ theme }) => theme.spacing.S8};
`;

const NavigationButton = styled.button`
  display: none;

  ${media.medium} {
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: rgba(0, 0, 0, 0.48);
    color: ${({ theme }) => theme.colors.WHITE};
    padding: ${({ theme }) => theme.spacing.S4};
    height: 32px;
    width: 32px;
    border-radius: 50%;
    transition: all 0.2s ease-in-out;

    &:hover {
      background-color: rgba(0, 0, 0, 0.8);
    }

    &:disabled {
      background-color: rgba(0, 0, 0, 0.12);
      cursor: not-allowed;
    }
  }
`;

const Carousel = styled.div`
  overflow-x: auto;
  scroll-behavior: smooth;
  display: flex;
  gap: ${({ theme }) => theme.spacing.S8};
  padding: ${({ theme }) => theme.spacing.S4};
`;

export {
  Container,
  Heading,
  Title,
  NavigationButtonContainer,
  NavigationButton,
  Carousel,
};
